module.exports = __webpack_public_path__ + "img/LapInvoice.1fcdbae0.svg";